import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import debounce from "lodash.debounce";
import { AiOutlineSearch } from "react-icons/ai";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import axioPath from '../../../../../api/axioPath';
import Spinner from '../../../../components/Spinner'
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import CsvDownloader from 'react-csv-downloader';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { addminFetchLocationsList } from '../../../../../redux/actions/admin';
import { SearchWrapper } from '../DashBoard/dashBoardStyled'

import AlertModal from 'web/components/AlertModal';

import SubLocationsListPage from './SubLocationsListPage';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import styled from 'styled-components';

function LocationManagement() {
  let dispatch = useDispatch()
  let history = useHistory()
  const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }

  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const [activePage, setActivePage] = useState('MainLocations')
  const [selectedId, setSelectedId] = useState('')
  const [dataList, setDataList] = useState([])
  const [finalData, setFinalData] = useState([])
  const [subLocationsList, setSubLocationsList] = useState([])
  const [csvData, setCsvData] = useState([])
  const [tableSearch, setTableSearch] = useState('')
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [searchDataList, setSearchDataList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [totalNumberElement, settotalNumberElement] = useState(10);
  const toggleModal = () => { setModal(!modal); }

  const switchActivePage = (value) => {
    setActivePage(value)
  }

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    fetchMyAPI(page, tableSearch);
  }, []);

  // fetch promocode list
  const fetchMyAPI = async (pageNumber, search) => {
    let response = '';
    response = await dispatch(addminFetchLocationsList(pageNumber, search));
    if (response.data && response.data.status === 'SUCCESS') {
      if (response.data?.payload?.content) {
        let adminAllLocationsList = response.data?.payload?.content
        setDataList(adminAllLocationsList)
        setSearchDataList(adminAllLocationsList)
        settotalNumberElement(response.data?.payload?.totalElements)

        // //set data for csv export
        // setCSVDate(adminAllLocationsList)

        setPageCount(response.data?.payload?.totalPages)
        setFinalData(response.data?.payload?.content)
      }
    }
    else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.data?.message || response.message)
        setModal(!modal)
      }
    }
  };

  let headerArr = [
    { title: 'Location Name', },
    { title: 'Email Id ', },
    { title: 'Address', },
    { title: 'FC Member ', },
    { title: 'Account Type', },
    { title: 'Broker', },
    { title: 'Location Status', }
  ];

  const handleChange = (event, value) => {
    setPage(value);
    fetchMyAPI(value, tableSearch)
  };

  const handleSearchChange = e => {
    let search = e.target.value
    setTableSearch(search)
    handleDebounceSearch(search);
  }

  const handleDebounceSearch = useCallback(debounce((value) => fetchMyAPI(1, value), 500), []);

  const handleStatusChange = (e, items) => {
    e.preventDefault()
    const token = localStorage.getItem("token");
    let url = ''
    if (items.active) url = '/user/location/deactivate'
    else url = '/user/location/activate'
    axioPath.post(url, {}, {
      headers: {
        Authorization: `${token}`,
        authId: items.authId,
        locationId: items.id
      },
    }).then((response) => {
      setModal(!modal)
      setModalContent(response.data.message)
      fetchMyAPI(page, tableSearch)
    }).catch((ex) => {
    });
  }

  //click a promocode to see the list of users
  const handleIdClick = (items) => {
    if (items?.subLocationList) {
      setSelectedId(items.id)
      setSubLocationsList(items)
      setActivePage('subLocationsList')
    }

  }

  const fetchMyAPISubLocation = async (value, item, idValue) => {
    let response = '';
    response = await dispatch(addminFetchLocationsList(page, tableSearch));
    if (response.data && response.data.status === 'SUCCESS') {
      if (response.data?.payload?.content) {
        let adminAllLocationsList = response.data?.payload?.content
        setDataList(adminAllLocationsList)
        setSearchDataList(adminAllLocationsList)

        //set data for csv export
        setCSVDate(adminAllLocationsList)

        setPageCount(response.data?.payload?.totalPages)
        setFinalData(response.data?.payload?.content)

        //update sublocation list status   

        if (value === 'updateSubList') {
          let selectedLocation = adminAllLocationsList.filter(val => val.id === item.id)

          setSelectedId(item.id)
          setSubLocationsList(selectedLocation[0])
          setActivePage('subLocationsList')
        }

      }
    }
    else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.data?.message || response.message)
        setModal(!modal)
      }
    }

  }

  //for csv download
  const columns = [
    { id: 'LocationName', displayName: 'Location Name' },
    { id: 'LocationType', displayName: 'Location Type' },
    { id: 'FC_Member', displayName: 'FC Member' },
    { id: 'AccountType', displayName: 'Account Type' },
    { id: 'Broker', displayName: 'Broker' },
    { id: 'City', displayName: 'City' },
    { id: 'State', displayName: 'State' },
    { id: 'Zip', displayName: 'Zip' },
    { id: 'Status', displayName: 'Location Status' },
    { id: 'UserEmails', displayName: 'User Emails' },
    { id: 'MainLocationName', displayName: 'Main Location Name' },
  ]

  const setCSVDate = (dataList) => {
    let tempCsvData = dataList.map(items => {
      let mainLocationname = items.locationName
      let subLocListTemp = []
      let mainLocListTemp = []
      if (items.subLocationList?.length > 0) {
        subLocListTemp = items.subLocationList.map(subItems => {
          return ({
            LocationName: subItems.locationName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
            LocationType: 'Sub Location',
            FC_Member: items.innerCircle ? 'Yes' : 'No',
            AccountType: (items.isBuying && items.isSelling) ? 'Both' : items.isBuying ? 'Buyer' : items.isSelling ? 'Seller' : 'NA',
            Broker: items.isReselling ? 'Yes' : 'No',
            City: subItems.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
            State: stateConvert(subItems.address?.state),
            Zip: subItems.address?.zip,
            Status: subItems.active ? 'Active' : 'Inactive',
            UserEmails: subItems.corporateSubAccounts.map(val => val.email)?.join(';'),
            MainLocationName: mainLocationname?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
          })
        })
      }
      mainLocListTemp = [{
        LocationName: items.locationName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        LocationType: 'Main Location',
        FC_Member: items.innerCircle ? 'Yes' : 'No',
        AccountType: (items.isBuying && items.isSelling) ? 'Both' : items.isBuying ? 'Buyer' : items.isSelling ? 'Seller' : 'NA',
        Broker: items.isReselling ? 'Yes' : 'No',
        City: items.address?.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
        State: stateConvert(items.address?.state),
        Zip: items.address?.zip,
        Status: items.active ? 'Active' : 'Inactive',
        UserEmails: items.corporateSubAccounts.map(val => val.email)?.join(';'),
        MainLocationName: 'NA',
      }]

      if (subLocListTemp?.length > 0) {
        let concatData = [...mainLocListTemp, ...subLocListTemp]
        return concatData
      } else {
        return mainLocListTemp
      }
    })

    return (tempCsvData.flat())
    //  setCsvData(tempCsvData.flat())

  }

  const ExportFunction = async () => {
    let response = '';
    response = await dispatch(addminFetchLocationsList(1, tableSearch, totalNumberElement));
    if (response.data && response.data.status === 'SUCCESS') {
      if (response.data?.payload?.content) {
        let adminAllLocationsList = response.data?.payload?.content
        let csvData = setCSVDate(adminAllLocationsList)
        return (csvData)
      }
    }
    else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.data?.message || response.message)
        setModal(!modal)
      }
    }

  }

  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('LOCATION_MANAGEMENT'))) ?

        <>
          {activePage === 'MainLocations' &&
            <TableWrapper>
              {loaderVisible && <Spinner />}
              <Heading>
                <h3>Main Locations List</h3>
                <RightSection>

                  <SearchWrapper>
                    <input type="text" placeholder='Search' value={tableSearch}
                      onChange={handleSearchChange} />
                    <AiOutlineSearch />
                  </SearchWrapper>
                  <CsvDownloader
                    filename="Locations Details"
                    columns={columns}
                    datas={ExportFunction}>
                    <button
                      style={buttonStyle}>
                      Export
                    </button>
                  </CsvDownloader>
                </RightSection>
              </Heading>
              <Table responsive>
                <thead>
                  <tr>
                    {headerArr.map((items, index) => (
                      <th key={index + 1}>{items.title}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {
                    finalData.map((items, index) => (
                      <tr key={index + 1}>
                        <td><a style={{ color: '#00b2fe', cursor: 'pointer' }}
                          onClick={e => handleIdClick(items)}
                        >{items.locationName}</a></td>
                        <td>{items.corporateSubAccounts[0]?.email}</td>
                        <td>{items.address && `${items.address.city}, ${stateConvert(items.address?.state)}, ${items.address.zip}`}</td>
                        <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                        <td>{(items.isBuying && items.isSelling) ? 'Both' : items.isBuying ? 'Buyer' : items.isSelling ? 'Seller' : 'NA'}</td>
                        <td>{items.isReselling ? 'Yes' : 'No'}</td>
                        <td>{items.active ? 'Active' : 'Inactive'}
                          {/* <FormControlLabel
                              style={{ margin: 0 }}
                              labelPlacement="start"
                              label={items.active ? 'Active' : 'Inactive'}
                              control={
                                  <Switch
                                      checked={items.active}
                                      onClick={e => handleStatusChange(e, items)}
                                      name="checkedB"
                                      color="primary"
                                  />
                              }
                          /> */}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {finalData.length === 0 && !loaderVisible &&
                <p style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>No records found</p>
              }
              {finalData.length != 0 && dataList.length !== 0 && <Pagination count={pageCount}
                page={page}
                onChange={handleChange} />}
            </TableWrapper>
          }
          {activePage === 'subLocationsList' && <SubLocationsListPage togglePage={switchActivePage} subLocationsList={subLocationsList} fetchMyAPISubLocation={fetchMyAPISubLocation} />}

          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title=''
            content={modalContent}
          />
        </>

        :

        <p>You are not authorized to view this page.</p>
      }
    </>

  )
};

export default LocationManagement;

const RightSection = styled.div`
        display: grid;
        grid-auto-flow: column;
        gap: 10px;
        @media(max-width:500px) {
            display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        }
    `